<template>
<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.51728 8.6875H16.4813C17.76 8.6875 18.7986 9.72617 18.7986 11.0048V15.6555H2.19995V11.0048C2.19995 9.72617 3.23862 8.6875 4.51728 8.6875Z" stroke="#1D2329" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.59595 17.3429V15.9629" stroke="#1D2329" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.3893 17.3429V15.9629" stroke="#1D2329" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.68933 8.35522V3.69922H17.3107V8.35522" stroke="#1D2329" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.89063 6.38867H6.32797C5.95389 6.38867 5.65063 6.69163 5.65063 7.06534C5.65063 7.43905 5.95389 7.74201 6.32797 7.74201H8.89063C9.26472 7.74201 9.56797 7.43905 9.56797 7.06534C9.56797 6.69163 9.26472 6.38867 8.89063 6.38867Z" stroke="#1D2329" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.6719 6.38867H12.1093C11.7352 6.38867 11.4319 6.69163 11.4319 7.06534C11.4319 7.43905 11.7352 7.74201 12.1093 7.74201H14.6719C15.046 7.74201 15.3493 7.43905 15.3493 7.06534C15.3493 6.69163 15.046 6.38867 14.6719 6.38867Z" stroke="#1D2329" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>

<script setup></script>

<style scoped>
  /* Add custom styles if needed */
</style>
